import type { AllUsersResponse, userResponse } from "@shared/types/user.types";
import type { SurveyContact } from "@survey-types/survey.contacts.types";
import type { Layouts } from "@survey-types/survey.leaseComp.types";
import { userApi } from "./base";

export const userApiExtended = userApi.injectEndpoints({
  endpoints: (build) => ({
    getTeamUsers: build.query<SurveyContact[], { teamId: string }>({
      query: ({ teamId }) => `data/teams/${teamId}/users`,
      providesTags: [{ type: "TeamUsers" }],
    }),
    getCustomUsers: build.query<SurveyContact[], { teamId: string }>({
      query: ({ teamId }) => `data/customUsers/team/${teamId}`,
      providesTags: [{ type: "CustomUsers" }],
    }),
    getCollabUsers: build.query<SurveyContact[], { projectId: string }>({
      query: ({ projectId }) => `data/projects/${projectId}/users`,
      providesTags: [{ type: "CollabUsers" }],
    }),
    getAllUsers: build.query<AllUsersResponse, void>({
      query: () => `data/users`,
      providesTags: [{ type: "AllUsers" }],
    }),
    getLeaseCompLayouts: build.query<Layouts[], { teamId: string }>({
      query: ({ teamId }) => `project/layout/team/${teamId}?layoutType=comps`,
      providesTags: [{ type: "LeaseCompLayouts" }],
    }),
    getTeamPropertyLayouts: build.query<Layouts[], { teamId: string }>({
      query: ({ teamId }) => `project/layout/team/${teamId}`,
      providesTags: [{ type: "TeamPropertyLayouts" }],
    }),
    getTableConfig: build.query<userResponse, { email: string }>({
      query: ({ email }) => `data/users/email/${email}`,
      providesTags: [{ type: "TableConfigs" }],
    }),
  }),
});

export const {
  useGetTeamUsersQuery,
  useGetCustomUsersQuery,
  useGetCollabUsersQuery,
  useGetAllUsersQuery,
  useGetLeaseCompLayoutsQuery,
  useGetTeamPropertyLayoutsQuery,
  useGetTableConfigQuery,
} = userApiExtended;
